import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import Icon from '@components/Icon/Icon';
import AttachmentActions from './AttachmentActions';

const AttachmentOrderControls = ({
    editable,
    showOrderControls,
    canMoveUp,
    canMoveDown,
    onMoveUp,
    onMoveDown,
    position // 'left' or 'right'
}) => {
    const { t } = useLanguage();

    if (!showOrderControls || !editable) return null;

    if (position === 'left') {
        return (
            <button
                type="button"
                onClick={onMoveUp}
                disabled={!canMoveUp}
                className="action-btn order-btn order-btn-left"
                title={t('attachments.moveUp')}
            >
                <Icon icon="arrow-left" />
            </button>
        );
    }

    if (position === 'right') {
        return (
            <button
                type="button"
                onClick={onMoveDown}
                disabled={!canMoveDown}
                className="action-btn order-btn order-btn-right"
                title={t('attachments.moveDown')}
            >
                <Icon icon="arrow-right" />
            </button>
        );
    }

    return null;
};

const AttachmentInfo = ({
    attachment,
    file,
    formatFileSize,
    editable,
    showOrderControls,
    canMoveUp,
    canMoveDown,
    onMoveUp,
    onMoveDown,
    // Actions props
    canCrop,
    canAIEdit,
    isCropping,
    isAIEditing,
    onCrop,
    onAIEdit,
    onDelete
}) => {
    return (
        <div className="attachment-info">
            <div className="attachment-details">
                <div className="filename" title={file.filename}>
                    {file.filename}
                </div>
                <div className="file-meta">
                    <AttachmentOrderControls
                        editable={editable}
                        showOrderControls={showOrderControls}
                        canMoveUp={canMoveUp}
                        canMoveDown={canMoveDown}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                        position="left"
                    />
                    <span className="file-size">{formatFileSize(file.file_size)}</span>
                    <AttachmentOrderControls
                        editable={editable}
                        showOrderControls={showOrderControls}
                        canMoveUp={canMoveUp}
                        canMoveDown={canMoveDown}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                        position="right"
                    />
                </div>
                {attachment.description && (
                    <div className="description" title={attachment.description}>
                        {attachment.description}
                    </div>
                )}
            </div>

            {/* Action Buttons */}
            <AttachmentActions
                editable={editable}
                canCrop={canCrop}
                canAIEdit={canAIEdit}
                isCropping={isCropping}
                isAIEditing={isAIEditing}
                onCrop={onCrop}
                onAIEdit={onAIEdit}
                onDelete={onDelete}
            />
        </div>
    );
};

export default AttachmentInfo;
